import { Input, Text, makeStyles } from '@rneui/themed'
import { t } from 'app/i18l'
import { font } from 'app/theme'
import React from 'react'
import { View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

interface Props {
  text: string
  name: string
  onChangeText(inputText: string): void
  error?: any
}

export function TextSettingView(props: Props) {
  const styles = useStyles()

  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.root}>
      <View style={styles.parentContainer}>
        <View style={styles.container}>
          <Input
            style={styles.input}
            placeholder={`${t('enter')} ${props.name}`}
            value={props.text}
            onChangeText={props.onChangeText}
            multiline
          />
        </View>
        {props.error ? (
          <Text style={styles.error}>{props.error.message}</Text>
        ) : null}
      </View>
    </SafeAreaView>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
  },
  parentContainer: {
    flex: 1,
  },
  container: {
    backgroundColor: theme.colors?.white,
    margin: 10,
    padding: 10,
    flexDirection: 'row',
  },
  input: {
    flex: 1,
    height: 200,
    textAlignVertical: 'top',
    backgroundColor: 'white',
    paddingLeft: 10,
    color: 'black',
  },
  error: {
    margin: 10,
    textAlign: 'center',
    color: theme.colors?.primary,
    fontFamily: font.bold,
    fontSize: 16,
  },
}))
